import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2024M03D24() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2024-03-24.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
              Photo by Kandukuru Nagarjun (Flickr images)
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                  15-17 March 2024, Labyrinth, Zagarolo (Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Toward a New Anthropology of Relations</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    <b>Project Animism in Practice</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The aim of this workshop is a reeducation of perception, imagination, and cognition, as proposed by <i>Alain Daniélou’s Shiva and Dionysus</i>, according to parameters of traditional cultures (in South Asia, West Africa, and South America), the world-configuration of which challenges the Western notions of individual and environment, nature and society, right and wrong, normalcy and pathology. 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
